export function SubmitDealHero() {
  return (
    <section className="relative bg-gradient-to-br from-emerald-50 via-white to-teal-50 pt-32 pb-20">
      <div className="absolute inset-0 bg-[url('https://public.readdy.ai/ai/img_res/206e2ed8f876ccb00654dba6e16a7ff0.jpg')] opacity-5 bg-cover bg-center"></div>
      
      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="text-center max-w-4xl mx-auto">
          <div className="inline-flex items-center gap-2 bg-emerald-100 text-emerald-700 px-4 py-2 rounded-full text-sm font-medium mb-6">
            <i className="ri-price-tag-3-line"></i>
            <span>Reach 50,000+ Local Shoppers Monthly</span>
          </div>
          
          <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6 leading-tight">
            Promote Your Deals to<br />Roseville Residents
          </h1>
          
          <p className="text-xl text-gray-600 mb-8 leading-relaxed">
            Get your special offers, discounts, and promotions in front of thousands of local customers actively searching for deals in Roseville. Drive foot traffic, boost sales, and build customer loyalty.
          </p>
          
          <div className="flex flex-wrap items-center justify-center gap-6 text-sm text-gray-700">
            <div className="flex items-center gap-2">
              <i className="ri-check-line text-emerald-600 text-lg"></i>
              <span>Instant Visibility</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-check-line text-emerald-600 text-lg"></i>
              <span>Track Redemptions</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-check-line text-emerald-600 text-lg"></i>
              <span>Performance Analytics</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-check-line text-emerald-600 text-lg"></i>
              <span>No Setup Fees</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}